<template>
  <div
    v-if="content_type === 'rich'"
    v-html="SanitizedHtml"
    class="rich-text"
  />
  <h1 v-else-if="type === 'heading'">{{ SanitizedHtml }}</h1>
  <h3 v-else-if="type === 'subheading'">{{ SanitizedHtml }}</h3>
  <p v-else>{{ SanitizedHtml }}</p>
</template>

<script setup lang="ts">
import DOMPurify from "dompurify";

import { TextProps } from "~/types/schemas/common/Atom/text";

const props = withDefaults(defineProps<TextProps>(), {
  type: "paragraph",
  content_type: "plain",
  value: "Add your text here",
});

const SanitizedHtml = computed(() => {
  if (props.content_type !== "rich") return props.value.replace(/<[^>]*>/g, "");
  return DOMPurify.sanitize(props.value, {
    ALLOWED_TAGS: [
      "p",
      "br",
      "hr",
      "div",
      "span",
      "blockquote",
      "pre",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "s",
      "small",
      "sub",
      "sup",
      "mark",
      "a",
      "ul",
      "ol",
      "li",
      "dl",
      "dt",
      "dd",
      "img",
      "figure",
      "figcaption",
      "table",
      "thead",
      "tbody",
      "tfoot",
      "tr",
      "th",
      "td",
      "caption",
    ],
    ALLOWED_ATTR: [
      "href",
      "title",
      "target",
      "rel",
      "src",
      "alt",
      "width",
      "height",
      "colspan",
      "rowspan",
      "class",
      "style",
    ],
  });
});
</script>
